module.exports = __webpack_public_path__ + "img/saba_aya_no.8ea46c4c.png";